import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import gql from "graphql-tag";
import { CHARGE, MOCK_CHARGE } from "src/app/shared/queries/simpayx-payment-queries";
import { LOCAL_STORAGE } from "src/app/shared/constants/local-storage.constants";
import { CustomerInput } from "src/app/shared/models/customer.model";
import { PaymentRequestInput } from "src/app/shared/models/simpayx-payment-request-model";
import { GET_RAZORPAY_ORDER_ID, VERIFY_PAYMENT_SIGNATURE } from "src/app/shared/queries/simpayx-payment-queries";
import { RazorpayCheckoutResponse } from "src/app/shared/models/payment.model";
import { StorageService } from "src/app/shared/services/storage.service";



export const GET_PAYMENT_METHOD = gql`
	query GetPaymentMethods($customerId: String, $businessId: String) {
		GetPaymentMethods(customerId: $customerId, businessId: $businessId) {
			name
			brand
			cardId
			expYear
			expMonth
			last4digit
		}
	}
`;

export const SAVE_CARD = gql`
	mutation CreatePaymentCustomer(
		$paymentMethodId: String
		$customer: CustomerInput!
		$businessId: String
	) {
		CreatePaymentCustomer(
			paymentMethodId: $paymentMethodId
			customer: $customer
			businessId: $businessId
		)
	}
`;

export const DELETE_CARDS = gql`
	mutation DeletePaymentMethod($paymentMethodId: String, $businessId: String) {
		DeletePaymentMethod(
			paymentMethodId: $paymentMethodId
			businessId: $businessId
		)
	}
`;

@Injectable({
	providedIn: "root",
})
export class PaymentService {
	name!: string;

	constructor(public apollo: Apollo, private storageService: StorageService) {}

	public createCharges(paymentRequest: any) {
		console.log("paymentRequest", paymentRequest);

		return this.apollo.watchQuery({
			query: CHARGE,
			variables: {
				paymentRequest: paymentRequest,
				isTnCAccepted: true,
			},
		});
	}
	public createMockCharges(type: any) {
		return this.apollo.watchQuery({
			query: MOCK_CHARGE,
			variables: {
				type: type
			},
		});
	}

	public getPaymentMethodList(customerId: String) {
		// let customerId = "cus_LsIAIkqcvRwHVh"
		let businessId = this.storageService.getLocalStorageData(
			LOCAL_STORAGE.BUSINESS_VALUES
		  ).businessId;

		return this.apollo.watchQuery({
			query: GET_PAYMENT_METHOD,
			variables: {
				customerId: customerId,
				businessId: businessId,
			},
			fetchPolicy: "network-only",
		}).valueChanges;
	}

	public saveCard(paymentMethodId: String, customer: CustomerInput) {
		let businessId = this.storageService.getLocalStorageData(
			LOCAL_STORAGE.BUSINESS_VALUES
		  ).businessId;
		// let businessDetails = {
		// businessId: businessId
		// }
		return this.apollo.mutate({
			mutation: SAVE_CARD,
			variables: {
				paymentMethodId: paymentMethodId,
				customer: customer,
				businessId: businessId,
			},
		});
	}

	public deleteCards(paymentMethodId: String) {
		let businessId = this.storageService.getLocalStorageData(
			LOCAL_STORAGE.BUSINESS_VALUES
		  ).businessId;
		return this.apollo.mutate({
			mutation: DELETE_CARDS,
			variables: {
				paymentMethodId: paymentMethodId,
				businessId: businessId,
			},
		});
	}

	getRazorpayOrderId(razorpayPaymentRequest: PaymentRequestInput) {
		return this.apollo.mutate({
			mutation: GET_RAZORPAY_ORDER_ID,
			variables: {
				razorpayPaymentRequest: razorpayPaymentRequest,
			},
		});
	}

	verifyPaymentSignature(
		razorpayPaymentResponseInput: RazorpayCheckoutResponse,
		businesId: String
	) {
		console.log("razorpayPaymentResponseInput", razorpayPaymentResponseInput);
		return this.apollo.watchQuery({
			query: VERIFY_PAYMENT_SIGNATURE,
			variables: {
				verifyPaymentSignature: razorpayPaymentResponseInput,
				businessId : businesId
			},
		}).valueChanges;
	}
}
